export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "organization_crop_field": {
            "self": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Campo"])},
            "crop_field_code": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Código"])},
            "crop_field_location": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sector"])},
            "crop_field_zone": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ubicación (localidad/zona/sector)"])},
            "organization_producer": {
              "producer_code": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Código Productor"])},
              "producer_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Productor"])}
            }
          }
        }
      },
      "en": {
        "model": {
          "organization_crop_field": {
            "self": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Field"])},
            "crop_field_code": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code"])},
            "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name"])},
            "hectares": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Area(Ha)"])},
            "square_meters": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Area(m²)"])},
            "latitude": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Coordenada Y"])},
            "longitude": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Coordenada X"])}
          }
        }
      }
    }
  })
}